import { makeStyles } from "@material-ui/styles";

const gameDetailsStyles = makeStyles((theme) => ({
	contentContainer: {
		height: "100%"
	},
	detailsContainer: {
		margin: "auto",
		display: "flex",
		justifyContent: "flex-start",
		padding: theme.spacing(1)
	},
	firstColumn: {
		borderRight: `1px solid ${theme.palette.secondary.main}`
	},
	personnelContainer: {
		paddingTop: `${theme.spacing(0)} !important`
	},
	startDate: {
		"& .SingleDatePickerInput": {
			justifyContent: "space-between",
			paddingRight: 10
		}
	},
	eventTypeContainer: { overflowX: "auto" }
}));

export default gameDetailsStyles;
